import React from 'react';
import {
  selectFacetSchemaEnhancer,
  selectFacetStateToValue,
  selectFacetValueToQuery,
} from '@plone/volto/components/manage/Blocks/Search/components/base';
import {
  customSelectStyles,
  selectTheme,
} from '@plone/volto/components/manage/Blocks/Search/components/SelectStyling';
import {
  ClearIndicator,
  DropdownIndicator,
  MultiValueContainer,
  Option,
} from '@plone/volto/components/manage/Widgets/SelectStyling';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const SelectFacet = (props) => {
  const { facet, choices, reactSelect, isMulti, onChange, value, isEditMode } =
    props;
  const Select = reactSelect.default;
  const v = Array.isArray(value) && value.length === 0 ? null : value;

  const fieldLabel = facet?.title ?? facet?.field?.label ?? '';
  const inputId = `select-facet-${facet?.field?.value ?? 'field'}`;
  const labelId = `${inputId}-label`;

  // Estende os estilos base do Volto sobrescrevendo apenas o placeholder
  // #595959 sobre #ffffff = 7.0:1 — passa WCAG AA (4.5:1) e AAA (7.0:1)
  const accessibleStyles = {
    ...customSelectStyles,
    placeholder: (base) => ({
      ...base,
      color: '#595959',
    }),
  };

  return (
    <div className="select-facet">
      <span
        id={labelId}
        className="text-semi-bold text-up-01 border-bottom mb-3 pb-1"
      >
        {fieldLabel}
      </span>
      <Select
        inputId={inputId}
        aria-labelledby={labelId}
        placeholder={fieldLabel || 'Selecionar...'}
        className="react-select-container"
        classNamePrefix="react-select"
        options={choices}
        styles={accessibleStyles}
        theme={selectTheme}
        components={{
          DropdownIndicator,
          Option,
          MultiValueContainer,
          ClearIndicator,
        }}
        isDisabled={isEditMode}
        onChange={(data) => {
          if (data) {
            onChange(
              facet.field.value,
              isMulti ? data.map(({ value }) => value) : data.value,
            );
          } else {
            onChange(facet.field.value, isMulti ? [] : '');
          }
        }}
        isMulti={facet.multiple}
        isClearable={facet?.isClearable !== false}
        value={v}
      />
    </div>
  );
};

SelectFacet.schemaEnhancer = selectFacetSchemaEnhancer;
SelectFacet.stateToValue = selectFacetStateToValue;
SelectFacet.valueToQuery = selectFacetValueToQuery;

export default injectLazyLibs('reactSelect')(SelectFacet);
